import { default as energy_45green_45practices6fQeowr7yhMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as fun_45part_45journey1VGdRlm94cMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as homesafe_45colorado_45master_45buildergEdBMCq6qEMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as index3RwoZ5Pt2HMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as our_45team59SlygqIPxMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as preferred_45lenderNH3kkuYQW2Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as realtor_45resourcesY1kDwFaeEWMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as _91post_93KCoMVBWwKyMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indexC6wq3Y8hLjMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as index3FsIPVnkfTMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_93mNEwQKrZOCMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as index3apTE81AZ7Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as central_45park_45special_45offerLYmElBka36Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as ask_45a_45questionLEzj9MCdFWMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as career_45opportunitiesGOZVj61v8UMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as faqOxpANANkV5Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as homeowner_45resources55faLpA3ReMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as indexlTRkxJ3Z7NMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as our_45locationsyv1TUpcEGBMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as current_45offerszpM2kE9GjOMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as index0sSx986CfnMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as indextWv4FOs5n7Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as indexSXIM5hwY2QMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as indexGGtXrkDqOzMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as indexXs2cG8uVBHMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as indexJTiAEtFiZPMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as indexlkD9oOeEJqMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as knolls_45hoa_45informationLlkeIrRLAgMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as land_45acquisitionHCoqk5qqCQMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as brents_45placeGtBx9OlXwjMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as experience_45lower_45maintenancenNjAJhYVytMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as _91testimonial_93vzzOlC55CJMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as indexiQP1RpDwjgMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as indexZhoGDj30VGMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as whats_45lifefullnessTrsB2jv6vEMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as _91_46_46_46slug_93gCm3vhAvu3Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as my_45favorites8yZZDhKivuMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/my-favorites.vue?macro=true";
import { default as new_45home_45searchDpSbWFmleeMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as easyhouse2qzqSnxoi2Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as limitededitionszBF1Pvv1bMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as wee_45cottagePoSn1euDvgMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as index4lUgV3NnhNMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as our_45neighborhoodsERrhvLPqoMMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as partner_45with_45uscc0um8u1XBMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as peacockcn6cGERLV0Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/peacock.vue?macro=true";
import { default as privacytermsRLHgRNWEWgMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as sandboxUe8jxwh7S0Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as _91_46_46_46slug_93SiE0GzvjvSMeta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as component_45stubzfqMwVcJm0Meta } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubzfqMwVcJm0 } from "/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: energy_45green_45practices6fQeowr7yhMeta?.name ?? "about-us-energy-green-practices",
    path: energy_45green_45practices6fQeowr7yhMeta?.path ?? "/about-us/energy-green-practices",
    meta: energy_45green_45practices6fQeowr7yhMeta || {},
    alias: energy_45green_45practices6fQeowr7yhMeta?.alias || [],
    redirect: energy_45green_45practices6fQeowr7yhMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue").then(m => m.default || m)
  },
  {
    name: fun_45part_45journey1VGdRlm94cMeta?.name ?? "about-us-fun-part-journey",
    path: fun_45part_45journey1VGdRlm94cMeta?.path ?? "/about-us/fun-part-journey",
    meta: fun_45part_45journey1VGdRlm94cMeta || {},
    alias: fun_45part_45journey1VGdRlm94cMeta?.alias || [],
    redirect: fun_45part_45journey1VGdRlm94cMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue").then(m => m.default || m)
  },
  {
    name: homesafe_45colorado_45master_45buildergEdBMCq6qEMeta?.name ?? "about-us-homesafe-colorado-master-builder",
    path: homesafe_45colorado_45master_45buildergEdBMCq6qEMeta?.path ?? "/about-us/homesafe-colorado-master-builder",
    meta: homesafe_45colorado_45master_45buildergEdBMCq6qEMeta || {},
    alias: homesafe_45colorado_45master_45buildergEdBMCq6qEMeta?.alias || [],
    redirect: homesafe_45colorado_45master_45buildergEdBMCq6qEMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue").then(m => m.default || m)
  },
  {
    name: index3RwoZ5Pt2HMeta?.name ?? "about-us",
    path: index3RwoZ5Pt2HMeta?.path ?? "/about-us",
    meta: index3RwoZ5Pt2HMeta || {},
    alias: index3RwoZ5Pt2HMeta?.alias || [],
    redirect: index3RwoZ5Pt2HMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45team59SlygqIPxMeta?.name ?? "about-us-our-team",
    path: our_45team59SlygqIPxMeta?.path ?? "/about-us/our-team",
    meta: our_45team59SlygqIPxMeta || {},
    alias: our_45team59SlygqIPxMeta?.alias || [],
    redirect: our_45team59SlygqIPxMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue").then(m => m.default || m)
  },
  {
    name: preferred_45lenderNH3kkuYQW2Meta?.name ?? "about-us-preferred-lender",
    path: preferred_45lenderNH3kkuYQW2Meta?.path ?? "/about-us/preferred-lender",
    meta: preferred_45lenderNH3kkuYQW2Meta || {},
    alias: preferred_45lenderNH3kkuYQW2Meta?.alias || [],
    redirect: preferred_45lenderNH3kkuYQW2Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue").then(m => m.default || m)
  },
  {
    name: realtor_45resourcesY1kDwFaeEWMeta?.name ?? "about-us-realtor-resources",
    path: realtor_45resourcesY1kDwFaeEWMeta?.path ?? "/about-us/realtor-resources",
    meta: realtor_45resourcesY1kDwFaeEWMeta || {},
    alias: realtor_45resourcesY1kDwFaeEWMeta?.alias || [],
    redirect: realtor_45resourcesY1kDwFaeEWMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue").then(m => m.default || m)
  },
  {
    name: _91post_93KCoMVBWwKyMeta?.name ?? "blog-post",
    path: _91post_93KCoMVBWwKyMeta?.path ?? "/blog/:post()",
    meta: _91post_93KCoMVBWwKyMeta || {},
    alias: _91post_93KCoMVBWwKyMeta?.alias || [],
    redirect: _91post_93KCoMVBWwKyMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/blog/[post].vue").then(m => m.default || m)
  },
  {
    name: indexC6wq3Y8hLjMeta?.name ?? "blog-category-category",
    path: indexC6wq3Y8hLjMeta?.path ?? "/blog/category/:category()",
    meta: indexC6wq3Y8hLjMeta || {},
    alias: indexC6wq3Y8hLjMeta?.alias || [],
    redirect: indexC6wq3Y8hLjMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: index3FsIPVnkfTMeta?.name ?? "blog",
    path: index3FsIPVnkfTMeta?.path ?? "/blog",
    meta: index3FsIPVnkfTMeta || {},
    alias: index3FsIPVnkfTMeta?.alias || [],
    redirect: index3FsIPVnkfTMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93mNEwQKrZOCMeta?.name ?? "campaigns-slug",
    path: _91_46_46_46slug_93mNEwQKrZOCMeta?.path ?? "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_93mNEwQKrZOCMeta || {},
    alias: _91_46_46_46slug_93mNEwQKrZOCMeta?.alias || [],
    redirect: _91_46_46_46slug_93mNEwQKrZOCMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index3apTE81AZ7Meta?.name ?? "campaigns",
    path: index3apTE81AZ7Meta?.path ?? "/campaigns",
    meta: index3apTE81AZ7Meta || {},
    alias: index3apTE81AZ7Meta?.alias || [],
    redirect: index3apTE81AZ7Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: central_45park_45special_45offerLYmElBka36Meta?.name ?? "central-park-special-offer",
    path: central_45park_45special_45offerLYmElBka36Meta?.path ?? "/central-park-special-offer",
    meta: central_45park_45special_45offerLYmElBka36Meta || {},
    alias: central_45park_45special_45offerLYmElBka36Meta?.alias || [],
    redirect: central_45park_45special_45offerLYmElBka36Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue").then(m => m.default || m)
  },
  {
    name: ask_45a_45questionLEzj9MCdFWMeta?.name ?? "contact-us-ask-a-question",
    path: ask_45a_45questionLEzj9MCdFWMeta?.path ?? "/contact-us/ask-a-question",
    meta: ask_45a_45questionLEzj9MCdFWMeta || {},
    alias: ask_45a_45questionLEzj9MCdFWMeta?.alias || [],
    redirect: ask_45a_45questionLEzj9MCdFWMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue").then(m => m.default || m)
  },
  {
    name: career_45opportunitiesGOZVj61v8UMeta?.name ?? "contact-us-career-opportunities",
    path: career_45opportunitiesGOZVj61v8UMeta?.path ?? "/contact-us/career-opportunities",
    meta: career_45opportunitiesGOZVj61v8UMeta || {},
    alias: career_45opportunitiesGOZVj61v8UMeta?.alias || [],
    redirect: career_45opportunitiesGOZVj61v8UMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue").then(m => m.default || m)
  },
  {
    name: faqOxpANANkV5Meta?.name ?? "contact-us-faq",
    path: faqOxpANANkV5Meta?.path ?? "/contact-us/faq",
    meta: faqOxpANANkV5Meta || {},
    alias: faqOxpANANkV5Meta?.alias || [],
    redirect: faqOxpANANkV5Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue").then(m => m.default || m)
  },
  {
    name: homeowner_45resources55faLpA3ReMeta?.name ?? "contact-us-homeowner-resources",
    path: homeowner_45resources55faLpA3ReMeta?.path ?? "/contact-us/homeowner-resources",
    meta: homeowner_45resources55faLpA3ReMeta || {},
    alias: homeowner_45resources55faLpA3ReMeta?.alias || [],
    redirect: homeowner_45resources55faLpA3ReMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue").then(m => m.default || m)
  },
  {
    name: indexlTRkxJ3Z7NMeta?.name ?? "contact-us",
    path: indexlTRkxJ3Z7NMeta?.path ?? "/contact-us",
    meta: indexlTRkxJ3Z7NMeta || {},
    alias: indexlTRkxJ3Z7NMeta?.alias || [],
    redirect: indexlTRkxJ3Z7NMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45locationsyv1TUpcEGBMeta?.name ?? "contact-us-our-locations",
    path: our_45locationsyv1TUpcEGBMeta?.path ?? "/contact-us/our-locations",
    meta: our_45locationsyv1TUpcEGBMeta || {},
    alias: our_45locationsyv1TUpcEGBMeta?.alias || [],
    redirect: our_45locationsyv1TUpcEGBMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue").then(m => m.default || m)
  },
  {
    name: current_45offerszpM2kE9GjOMeta?.name ?? "current-offers",
    path: current_45offerszpM2kE9GjOMeta?.path ?? "/current-offers",
    meta: current_45offerszpM2kE9GjOMeta || {},
    alias: current_45offerszpM2kE9GjOMeta?.alias || [],
    redirect: current_45offerszpM2kE9GjOMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/current-offers.vue").then(m => m.default || m)
  },
  {
    name: index0sSx986CfnMeta?.name ?? "events-event",
    path: index0sSx986CfnMeta?.path ?? "/events/:event()",
    meta: index0sSx986CfnMeta || {},
    alias: index0sSx986CfnMeta?.alias || [],
    redirect: index0sSx986CfnMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue").then(m => m.default || m)
  },
  {
    name: indextWv4FOs5n7Meta?.name ?? "events",
    path: indextWv4FOs5n7Meta?.path ?? "/events",
    meta: indextWv4FOs5n7Meta || {},
    alias: indextWv4FOs5n7Meta?.alias || [],
    redirect: indextWv4FOs5n7Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: indexSXIM5hwY2QMeta?.name ?? "homes-location-community",
    path: indexSXIM5hwY2QMeta?.path ?? "/homes/:location()/:community()",
    meta: indexSXIM5hwY2QMeta || {},
    alias: indexSXIM5hwY2QMeta?.alias || [],
    redirect: indexSXIM5hwY2QMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue").then(m => m.default || m)
  },
  {
    name: indexGGtXrkDqOzMeta?.name ?? "homes-location-community-models-model",
    path: indexGGtXrkDqOzMeta?.path ?? "/homes/:location()/:community()/models/:model()",
    meta: indexGGtXrkDqOzMeta || {},
    alias: indexGGtXrkDqOzMeta?.alias || [],
    redirect: indexGGtXrkDqOzMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue").then(m => m.default || m)
  },
  {
    name: indexXs2cG8uVBHMeta?.name ?? "homes-location-community-plans-plan",
    path: indexXs2cG8uVBHMeta?.path ?? "/homes/:location()/:community()/plans/:plan()",
    meta: indexXs2cG8uVBHMeta || {},
    alias: indexXs2cG8uVBHMeta?.alias || [],
    redirect: indexXs2cG8uVBHMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJTiAEtFiZPMeta?.name ?? "homes-location-community-qmi-home",
    path: indexJTiAEtFiZPMeta?.path ?? "/homes/:location()/:community()/qmi/:home()",
    meta: indexJTiAEtFiZPMeta || {},
    alias: indexJTiAEtFiZPMeta?.alias || [],
    redirect: indexJTiAEtFiZPMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue").then(m => m.default || m)
  },
  {
    name: indexlkD9oOeEJqMeta?.name ?? "index",
    path: indexlkD9oOeEJqMeta?.path ?? "/",
    meta: indexlkD9oOeEJqMeta || {},
    alias: indexlkD9oOeEJqMeta?.alias || [],
    redirect: indexlkD9oOeEJqMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: knolls_45hoa_45informationLlkeIrRLAgMeta?.name ?? "knolls-hoa-information",
    path: knolls_45hoa_45informationLlkeIrRLAgMeta?.path ?? "/knolls-hoa-information",
    meta: knolls_45hoa_45informationLlkeIrRLAgMeta || {},
    alias: knolls_45hoa_45informationLlkeIrRLAgMeta?.alias || [],
    redirect: knolls_45hoa_45informationLlkeIrRLAgMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue").then(m => m.default || m)
  },
  {
    name: land_45acquisitionHCoqk5qqCQMeta?.name ?? "land-acquisition",
    path: land_45acquisitionHCoqk5qqCQMeta?.path ?? "/land-acquisition",
    meta: land_45acquisitionHCoqk5qqCQMeta || {},
    alias: land_45acquisitionHCoqk5qqCQMeta?.alias || [],
    redirect: land_45acquisitionHCoqk5qqCQMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue").then(m => m.default || m)
  },
  {
    name: brents_45placeGtBx9OlXwjMeta?.name ?? "lifestyle-brents-place",
    path: brents_45placeGtBx9OlXwjMeta?.path ?? "/lifestyle/brents-place",
    meta: brents_45placeGtBx9OlXwjMeta || {},
    alias: brents_45placeGtBx9OlXwjMeta?.alias || [],
    redirect: brents_45placeGtBx9OlXwjMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue").then(m => m.default || m)
  },
  {
    name: experience_45lower_45maintenancenNjAJhYVytMeta?.name ?? "lifestyle-experience-lower-maintenance",
    path: experience_45lower_45maintenancenNjAJhYVytMeta?.path ?? "/lifestyle/experience-lower-maintenance",
    meta: experience_45lower_45maintenancenNjAJhYVytMeta || {},
    alias: experience_45lower_45maintenancenNjAJhYVytMeta?.alias || [],
    redirect: experience_45lower_45maintenancenNjAJhYVytMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue").then(m => m.default || m)
  },
  {
    name: _91testimonial_93vzzOlC55CJMeta?.name ?? "lifestyle-reviews-testimonial",
    path: _91testimonial_93vzzOlC55CJMeta?.path ?? "/lifestyle/reviews/:testimonial()",
    meta: _91testimonial_93vzzOlC55CJMeta || {},
    alias: _91testimonial_93vzzOlC55CJMeta?.alias || [],
    redirect: _91testimonial_93vzzOlC55CJMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue").then(m => m.default || m)
  },
  {
    name: indexiQP1RpDwjgMeta?.name ?? "lifestyle-reviews-category-category",
    path: indexiQP1RpDwjgMeta?.path ?? "/lifestyle/reviews/category/:category()",
    meta: indexiQP1RpDwjgMeta || {},
    alias: indexiQP1RpDwjgMeta?.alias || [],
    redirect: indexiQP1RpDwjgMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexZhoGDj30VGMeta?.name ?? "lifestyle-reviews",
    path: indexZhoGDj30VGMeta?.path ?? "/lifestyle/reviews",
    meta: indexZhoGDj30VGMeta || {},
    alias: indexZhoGDj30VGMeta?.alias || [],
    redirect: indexZhoGDj30VGMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: whats_45lifefullnessTrsB2jv6vEMeta?.name ?? "lifestyle-whats-lifefullness",
    path: whats_45lifefullnessTrsB2jv6vEMeta?.path ?? "/lifestyle/whats-lifefullness",
    meta: whats_45lifefullnessTrsB2jv6vEMeta || {},
    alias: whats_45lifefullnessTrsB2jv6vEMeta?.alias || [],
    redirect: whats_45lifefullnessTrsB2jv6vEMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93gCm3vhAvu3Meta?.name ?? "marshallfire-slug",
    path: _91_46_46_46slug_93gCm3vhAvu3Meta?.path ?? "/marshallfire/:slug(.*)*",
    meta: _91_46_46_46slug_93gCm3vhAvu3Meta || {},
    alias: _91_46_46_46slug_93gCm3vhAvu3Meta?.alias || [],
    redirect: _91_46_46_46slug_93gCm3vhAvu3Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites8yZZDhKivuMeta?.name ?? "my-favorites",
    path: my_45favorites8yZZDhKivuMeta?.path ?? "/my-favorites",
    meta: my_45favorites8yZZDhKivuMeta || {},
    alias: my_45favorites8yZZDhKivuMeta?.alias || [],
    redirect: my_45favorites8yZZDhKivuMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: new_45home_45searchDpSbWFmleeMeta?.name ?? "new-home-search",
    path: new_45home_45searchDpSbWFmleeMeta?.path ?? "/new-home-search",
    meta: new_45home_45searchDpSbWFmleeMeta || {},
    alias: new_45home_45searchDpSbWFmleeMeta?.alias || [],
    redirect: new_45home_45searchDpSbWFmleeMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/new-home-search.vue").then(m => m.default || m)
  },
  {
    name: easyhouse2qzqSnxoi2Meta?.name ?? "our-homes-home-collections-easyhouse",
    path: easyhouse2qzqSnxoi2Meta?.path ?? "/our-homes/home-collections/easyhouse",
    meta: easyhouse2qzqSnxoi2Meta || {},
    alias: easyhouse2qzqSnxoi2Meta?.alias || [],
    redirect: easyhouse2qzqSnxoi2Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue").then(m => m.default || m)
  },
  {
    name: limitededitionszBF1Pvv1bMeta?.name ?? "our-homes-home-collections-limitededition",
    path: limitededitionszBF1Pvv1bMeta?.path ?? "/our-homes/home-collections/limitededition",
    meta: limitededitionszBF1Pvv1bMeta || {},
    alias: limitededitionszBF1Pvv1bMeta?.alias || [],
    redirect: limitededitionszBF1Pvv1bMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue").then(m => m.default || m)
  },
  {
    name: wee_45cottagePoSn1euDvgMeta?.name ?? "our-homes-home-collections-wee-cottage",
    path: wee_45cottagePoSn1euDvgMeta?.path ?? "/our-homes/home-collections/wee-cottage",
    meta: wee_45cottagePoSn1euDvgMeta || {},
    alias: wee_45cottagePoSn1euDvgMeta?.alias || [],
    redirect: wee_45cottagePoSn1euDvgMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue").then(m => m.default || m)
  },
  {
    name: index4lUgV3NnhNMeta?.name ?? "our-homes",
    path: index4lUgV3NnhNMeta?.path ?? "/our-homes",
    meta: index4lUgV3NnhNMeta || {},
    alias: index4lUgV3NnhNMeta?.alias || [],
    redirect: index4lUgV3NnhNMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue").then(m => m.default || m)
  },
  {
    name: our_45neighborhoodsERrhvLPqoMMeta?.name ?? "our-neighborhoods",
    path: our_45neighborhoodsERrhvLPqoMMeta?.path ?? "/our-neighborhoods",
    meta: our_45neighborhoodsERrhvLPqoMMeta || {},
    alias: our_45neighborhoodsERrhvLPqoMMeta?.alias || [],
    redirect: our_45neighborhoodsERrhvLPqoMMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue").then(m => m.default || m)
  },
  {
    name: partner_45with_45uscc0um8u1XBMeta?.name ?? "partner-with-us",
    path: partner_45with_45uscc0um8u1XBMeta?.path ?? "/partner-with-us",
    meta: partner_45with_45uscc0um8u1XBMeta || {},
    alias: partner_45with_45uscc0um8u1XBMeta?.alias || [],
    redirect: partner_45with_45uscc0um8u1XBMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue").then(m => m.default || m)
  },
  {
    name: peacockcn6cGERLV0Meta?.name ?? "peacock",
    path: peacockcn6cGERLV0Meta?.path ?? "/peacock",
    meta: peacockcn6cGERLV0Meta || {},
    alias: peacockcn6cGERLV0Meta?.alias || [],
    redirect: peacockcn6cGERLV0Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/peacock.vue").then(m => m.default || m)
  },
  {
    name: privacytermsRLHgRNWEWgMeta?.name ?? "privacyterms",
    path: privacytermsRLHgRNWEWgMeta?.path ?? "/privacyterms",
    meta: privacytermsRLHgRNWEWgMeta || {},
    alias: privacytermsRLHgRNWEWgMeta?.alias || [],
    redirect: privacytermsRLHgRNWEWgMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/privacyterms.vue").then(m => m.default || m)
  },
  {
    name: sandboxUe8jxwh7S0Meta?.name ?? "sandbox",
    path: sandboxUe8jxwh7S0Meta?.path ?? "/sandbox",
    meta: sandboxUe8jxwh7S0Meta || {},
    alias: sandboxUe8jxwh7S0Meta?.alias || [],
    redirect: sandboxUe8jxwh7S0Meta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93SiE0GzvjvSMeta?.name ?? "videos-slug",
    path: _91_46_46_46slug_93SiE0GzvjvSMeta?.path ?? "/videos/:slug(.*)*",
    meta: _91_46_46_46slug_93SiE0GzvjvSMeta || {},
    alias: _91_46_46_46slug_93SiE0GzvjvSMeta?.alias || [],
    redirect: _91_46_46_46slug_93SiE0GzvjvSMeta?.redirect,
    component: () => import("/codebuild/output/src466585153/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/about-us/get-our-brochure/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/about-us/in-the-news/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/about-us/realtor-program/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/about-us/what-we-do/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/about-us/who-we-are/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/build-with-us/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/career-opportunities/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/career-opportunities/administrative-assistant-2/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/career-opportunities/director-of-warranty-services/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/career-opportunities/land-development-entitlements-coordinator/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/contact-us/ask-a-question/thank-you/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/contact-us/warranty-services/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/email-signup/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/get-updates/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/get-updates/thank-you/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/how-to-video-library/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/lifestyle/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/locations/lanterns-at-rock-creek/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/locations/silver-leaf/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/locations/wee-cottage-at-north-end-80238/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/locations/wee-cottage-at-rogers-farm/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/locations/west-edge-at-colliers-hill/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/login/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/lost-password/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/maintenance-items/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/marshall-fire-response/thank-you-loi/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/neighborhoods-map-test/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/organism-page/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/home-collections/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/home-collections/lanterns-series/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/home-collections/opportunities-series/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/photo-gallery/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/photo-gallery/gourmet-kitchens/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/photo-gallery/home-offices/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/photo-gallery/living-rooms/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/photo-gallery/outdoor-living-spaces/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/our-homes/photo-gallery/relaxing-master-suites/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/register/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/reset-password/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/resources-lower-maintenance/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/style-guide/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  },
  {
    name: component_45stubzfqMwVcJm0Meta?.name ?? undefined,
    path: component_45stubzfqMwVcJm0Meta?.path ?? "/warranty-service-request/",
    meta: component_45stubzfqMwVcJm0Meta || {},
    alias: component_45stubzfqMwVcJm0Meta?.alias || [],
    redirect: component_45stubzfqMwVcJm0Meta?.redirect,
    component: component_45stubzfqMwVcJm0
  }
]